/**
 * 预约看车记录
 */
import React from 'react';
import { Row, Col, DatePicker, Input, Tooltip, Icon, Select, Button } from 'antd';
import PageLayout from '../../ui/PageLayout';
import VehicleAppointmentEdit from './VehicleAppointmentEdit';
import http from '../../../axios/http';
import messager from '../../ui/messager';
import Loading from '../../ui/Loading';
import { global_data } from '../../ui/auth'

class VehicleAppointmentIndex extends React.Component {

    columns = [{
        title: '车商',
        dataIndex: 'memberName',
        width: '10%',
    }, {
        title: '车辆名称',
        dataIndex: 'vehicleName',
        width: '20%',
    }, {
        title: '顾客手机号',
        dataIndex: 'telephone',
        width: '8%',
        // }, {
        //     title: '预约时间是否确定',
        //     dataIndex: 'appointExact',
        //     width: '8%',
        //     format: { 0: '否', 1: '是' }
    },{
        title: '内部用户昵称',
        dataIndex: 'name',
        width: '8%',
    },{
        title: '内部用户电话',
        dataIndex: 'tel',
        width: '8%',
        // }, {
        //     title: '预约时间是否确定',
        //     dataIndex: 'appointExact',
        //     width: '8%',
        //     format: { 0: '否', 1: '是' }
    }, {
        title: '到店时间',
        dataIndex: 'appointmentStartTime',
        width: '15%',
        render: (text, record, index) => (
            <div>
                {record["appointExact"] !== 1 ? "" :
                    <Tooltip title={record["appointmentStartTime"] + " ~ " + record["appointmentEndTime"]}>
                        {record["appointmentStartTime"] + " ~ " + record["appointmentEndTime"]}
                    </Tooltip>
                }
            </div>
        )
    }, {
        title: '提交预约时间',
        dataIndex: 'insertTime',
        width: '10%',
    }, {
        title: '付款状态',
        dataIndex: 'state',
        width: '5%',
        format: { 0: '未付款', 1: '已付款' }
    },{
        title: '处理状态',
        dataIndex: 'status',
        width: '5%',
        format: { 0: '未处理', 1: '已处理' }
    }, {
        title: '操作',
        dataIndex: 'id',
        width: '7%',
        render: (text, record, index) => (
            <div>
                {global_data.authCode.includes("VEHICLE_APPOINTMENT_LOG_HANDLE")?
                <Tooltip title="处理预约信息">
                    <Icon type="edit" theme="filled" className="table-operate-icon" onClick={this.update.bind(this, record)} />
                </Tooltip>
                :""}
            </div>
        )
    }];

    state = {
        loadData: '',
        queryData: {},

        visible: false,
        editData: {},
        loadingVisible: false    //导出遮罩
    };

    //导出数据
    download = () => {
        let queryData = this.state.queryData;
        if (queryData.startDate == null || queryData.startDate === "") {
            messager.notify("请选择时间段进行导出！");
            return;
        }
        this.setState({ loadingVisible: true });
        queryData.pageNumber = 1;
        queryData.pageSize = 5000;
        http.download({
            url: '/vehicleAppointment/download',
            data: queryData,
            fileName: "预约看车记录.xlsx",
            success: (res) => {
                this.setState({ loadingVisible: false });
            },
            error: (res) => {
                this.setState({ loadingVisible: false });
            }
        });
    }

    rangePickerChange = (dates, dateStrings) => {
        let queryData = this.state.queryData;
        queryData.startDate = dateStrings[0];
        queryData.endDate = dateStrings[1];
        this.setState({ queryData: queryData });
        this.state.loadData(queryData);
    }

    inputSearch = (field, value) => {
        let queryData = this.state.queryData;
        queryData[field] = value
        this.state.loadData(queryData);
        this.setState({ queryData: queryData });
    }

    hiddenModal = () => {
        this.setState({ visible: false });
    }


    update = (info, e) => {
        let content = info.content;
        if (content != null && content !== "") {
            info["contentArray"] = JSON.parse(content);
            info["content"] = "";
        }
        this.setState({ editData: info, visible: true });
    }

    onSelect = (field, key) => {
        let queryData = this.state.queryData;
        queryData[field] = key;
        this.setState({ queryData: queryData });
        this.state.loadData(queryData);
    }

    render() {
        return (
            <div style={{ width: '100%', height: '100%' }}>
                <PageLayout
                    condition={(
                        <Row>
                            <Col span={24}>
                                <Input.Search
                                    placeholder="商户名称"
                                    onSearch={this.inputSearch.bind(this, "memberName")}
                                    enterButton
                                    style={{ margin: '0 10px', width: '200px' }}
                                />
                                <DatePicker.RangePicker onChange={this.rangePickerChange} />
                                <Select onChange={this.onSelect.bind(this, "status")} allowClear={true} style={{ margin: '0 10px', width: '150px' }} >
                                    <Select.Option key="0">未处理</Select.Option>
                                    <Select.Option key="1">已处理</Select.Option>
                                </Select>
                                <Button type="primary" onClick={this.download} style={{ "float": "right" }}>导出</Button>
                            </Col>
                        </Row>
                    )}
                    rowKey="id"
                    url="/vehicleAppointment/findAppointmentPage"
                    columns={this.columns}
                    loadData={(func) => { this.setState({ loadData: func }) }}
                />
                <VehicleAppointmentEdit
                    visible={this.state.visible}
                    onCancel={this.hiddenModal.bind(this)}
                    editData={this.state.editData}
                    successCallback={this.state.loadData}
                    queryData={this.state.queryData}
                />
                <Loading visible={this.state.loadingVisible} message="正在导出，请稍候..." />
            </div>
        )
    }
}

export default VehicleAppointmentIndex;